export default __webpack_public_path__ + "static/media/covid.b7347597.png";